import { join } from 'light-component';
import { Box } from '@common';
import * as Base from '@base';
import { Highlighter } from '../../component';
import { service } from '../service';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { InputProps } from './types';

export function InputInputMode(props: InputProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <Base.Input
          type='text'
          value={props.value}
          readOnly={props.readonly === true}
          placeholder={props.textPlaceholder}
          onChange={event => props.onPropsChange?.({ value: event.target.value })}
        />
      </Box>
    </Box>
  );
}
